import type { ChannelCheckSnapshot } from '@app/model/channel_check/ChannelCheckModels';

export const hasMeasuredNoClosures = (snapshot: Pick<ChannelCheckSnapshot, 'closedRuns' | 'channels'>): boolean => {
	const compared = snapshot.channels.filter(channel => channel.notComparedReason === null);
	return snapshot.closedRuns.length === 0 && compared.length >= 2 && compared.some(channel => channel.key === 'BRAND_COM');
};

export type ChannelCheckLadderEnd = 'cheapest' | 'most expensive';

// One card counts every place from one end of the ladder, so the two
// channels read in the same words. The Booking.com place picks the end.
export const channelCheckLadderEnd = (refRank: number, setSize: number): ChannelCheckLadderEnd =>
	2 * refRank > setSize + 1 ? 'most expensive' : 'cheapest';

const ordinal = (value: number) => {
	const mod100 = value % 100;
	if (mod100 >= 11 && mod100 <= 13) return `${value}th`;
	const mod10 = value % 10;
	return `${value}${mod10 === 1 ? 'st' : mod10 === 2 ? 'nd' : mod10 === 3 ? 'rd' : 'th'}`;
};

// rank is the backend rank: 1 + the number of strictly cheaper hotels.
// Counting from the top as setSize - rank + 1 keeps "N places apart" true.
export const channelCheckPositionWords = (rank: number, setSize: number, end: ChannelCheckLadderEnd): string => {
	const place = end === 'cheapest' ? rank : setSize - rank + 1;
	return place === 1 ? end : `${ordinal(place)} ${end}`;
};
